<template>
  <NodeTestimonial v-if="node" v-bind="node" />
</template>

<script lang="ts" setup>
definePageMeta({
  name: 'testimonial-detail',
  path: '/testimonial/:slug(.*)*',
})

const { entity: node } = await useDrupalRouteQuery('nodeTestimonial')

await renderPageDependencies()
</script>
